export default "__VITE_ASSET__EBkOhdMx__"